import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import Loading from '../_components/Loading';
import { apiConstants } from '../_constants';
import { sliderService } from '../_services/slider.service';

export const Slider = () => {
  const [sliderData, setSliderData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [query] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 100,
    },
    is_web: true,
  });
  useEffect(() => {
    getAllSliders();
  }, []);

  const getAllSliders = () => {
    setIsLoading(true);
    sliderService.sliderList(query).then(
      (res) => {
        setIsLoading(false);

        if (res.data.rows) {
          setSliderData(res.data.rows);
        }
      },
      (err) => {
        setIsLoading(false);

        console.log(err);
      },
    );
  };

  return (
    <div className='slidercontainer'>
      {!isLoading && (
        <Carousel
          showArrows={false}
          showThumbs={false}
          autoPlay={true}
          infiniteLoop={true}
          swipeable={true}
          emulateTouch={true}
          showIndicators={false}
          showStatus={false}
        >
          {sliderData.map((slider) => {
            return (
              <div key={slider}>
                <img src={apiConstants.imgUrl + slider?.image} />
              </div>
            );
          })}
        </Carousel>
      )}
      {isLoading && <Loading />}
    </div>
  );
};
